// import React, { useRef, useState } from 'react';
// import logo from '../../Assets/LOGICBUNNY.jpg';
// import dropdown_icon from '../../Assets/dropdown_icon.png';
// import { Link } from 'react-router-dom';
// import './navbar.css';

// const Navbar = () => {
//   const [menu, setMenu] = useState("");
//   const menuRef = useRef();

//   const dropdownToggle = (e) => {
//     menuRef.current.classList.toggle('nav-menu-visible');
//     e.target.classList.toggle('open');
//   };

//   return (
//     <div className='nav-container'>
//       <div className='logo'>
//         <img src={logo} alt="LogicBunny Logo" className="logo-img" />
//         <p className="logo-title">LogicBunny</p>
//       </div>
//       <img
//         className="nav-dropdown"
//         onClick={dropdownToggle}
//         src={dropdown_icon}
//         alt="Dropdown Icon"
//       />
//       <ul ref={menuRef} className="nav-list">
//         <li onClick={() => setMenu("home")}>
//           <Link className="nav-link" to='/'>
//             Home
//           </Link>
//           {menu === "home" ? <hr className="nav-underline" /> : null}
//         </li>
//         <li onClick={() => setMenu("career")}>
//           <Link className="nav-link" to='/career'>
//             Career
//           </Link>
//           {menu === "career" ? <hr className="nav-underline" /> : null}
//         </li>
//         <li onClick={() => setMenu("aboutus")}>
//           <Link className="nav-link" to='/aboutus'>
//             About Us
//           </Link>
//           {menu === "aboutus" ? <hr className="nav-underline" /> : null}
//         </li>
//         <li onClick={() => setMenu("portfolio")}>
//           <Link className="nav-link" to='/portfolio'>
//             Portfolio
//           </Link>
//           {menu === "portfolio" ? <hr className="nav-underline" /> : null}
//         </li>
//         <li onClick={() => setMenu("contactus")}>
//           <Link className="nav-link" to='/contactus'>
//             Contact Us
//           </Link>
//           {menu === "contactus" ? <hr className="nav-underline" /> : null}
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default Navbar;


import React, { useState, useRef } from 'react';
import logo from '../../Assets/LOGICBUNNY.jpg';
import dropdown_icon from '../../Assets/dropdown_icon.png';
import { Link } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className='nav-container'>
      {/* Logo Section */}
      <div className='logo'>
        <img src={logo} alt="LogicBunny Logo" className="logo-img" />
        <p className="logo-title">LogicBunny</p>
      </div>

      {/* Dropdown Icon (Mobile Menu) */}
      <img
        className={`nav-dropdown ${menuOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        src={dropdown_icon}
        alt="Dropdown Icon"
      />

      {/* Navigation Links */}
      <ul ref={menuRef} className={`nav-list ${menuOpen ? 'nav-menu-visible' : ''}`}>
        <li onClick={closeMenu}>
          <Link className="nav-link" to='/'>Home</Link>
        </li>
        <li onClick={closeMenu}>
          <Link className="nav-link" to='/career'>Career</Link>
        </li>
        <li onClick={closeMenu}>
          <Link className="nav-link" to='/aboutus'>About Us</Link>
        </li>
        <li onClick={closeMenu}>
          <Link className="nav-link" to='/portfolio'>Portfolio</Link>
        </li>
        <li onClick={closeMenu}>
          <Link className="nav-link" to='/contactus'>Contact Us</Link>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
